export const AI_BUDGET_REQUIRED_EVENT = 'ai-budget-required';

const normalizedCap = value => {
  const cap = Number(value);
  return Number.isFinite(cap) && cap > 0 ? cap : 10;
};

export function aiBudgetRequiredFromResponse(status, payload = {}) {
  if (Number(status) !== 402 || payload?.code !== 'INSUFFICIENT_LLM_CREDIT') return null;
  return { monthly_cap_usd: normalizedCap(payload.monthly_cap_usd) };
}

export function publishAiBudgetRequired(payload = {}) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(AI_BUDGET_REQUIRED_EVENT, {
    detail: { monthly_cap_usd: normalizedCap(payload.monthly_cap_usd) },
  }));
}

export function publishAiBudgetRequiredFromError(error) {
  const detail = aiBudgetRequiredFromResponse(error?.response?.status, error?.response?.data);
  if (detail) publishAiBudgetRequired(detail);
  return detail;
}

export async function publishAiBudgetRequiredFromFetch(response) {
  if (response?.status !== 402) return null;
  let payload = {};
  try { payload = await response.clone().json(); } catch {}
  const detail = aiBudgetRequiredFromResponse(response.status, payload);
  if (detail) publishAiBudgetRequired(detail);
  return detail;
}
